import { render, staticRenderFns } from "./ProductRfs.vue?vue&type=template&id=642ef9f3"
import script from "./ProductRfs.vue?vue&type=script&lang=js"
export * from "./ProductRfs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports